var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowAccordion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 23.5C22.5523 23.5 23 23.0523 23 22.5L23 13.5C23 12.9477 22.5523 12.5 22 12.5C21.4477 12.5 21 12.9477 21 13.5L21 21.5L13 21.5C12.4477 21.5 12 21.9477 12 22.5C12 23.0523 12.4477 23.5 13 23.5L22 23.5ZM0.292893 2.20711L21.2929 23.2071L22.7071 21.7929L1.70711 0.792893L0.292893 2.20711Z",
    fill: "#151518"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAccordion);
export default __webpack_public_path__ + "static/media/arrow-accordion.96a639ac35b39f79593b7019fb58df29.svg";
export { ForwardRef as ReactComponent };